<template>
  <div>
    <v-card>
        <v-toolbar  color="primary" dark height="40" >
            <v-toolbar-title>
              <v-layout>
                Basic Info.
              </v-layout>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small color="blue" @click.prevent="onEditQuote">Edit</v-btn>
        </v-toolbar>
      <v-card-text dense>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Quote # - Ver:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.num }} - {{ quoteData.basicInfo.ver }}</v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Status:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.statusId }}</v-flex>
        </v-layout>
        <v-layout row v-show="!quoteData.basicInfo.isCustomQuote">
          <v-flex xs4 body-2 pt-1>Total Amt.:</v-flex>
          <v-flex xs8 text-xs-left pt-1>
              {{ quoteData.basicInfo.totalAmountHasMultipleCurrencyError? ''
                : formatCurrency(quoteData.basicInfo.totalAmount, quoteData.basicInfo.totalAmountCurrnIdx) }}</v-flex>
        </v-layout>
        <v-layout row v-show="quoteData.basicInfo.soldToCode">
          <v-flex xs4 body-2 pt-1>Customer Acct #:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.soldToCode }}</v-flex>
        </v-layout>
        <v-layout row v-show="quoteData.basicInfo.soldToName">
          <v-flex xs4 body-2 pt-1>Customer Name:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.soldToName }}</v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Facility Acct #:</v-flex>
          <v-flex xs8 text-xs-left pt-1>

            <span v-if="quoteData.basicInfo.facilityAcctNo" > {{ quoteData.basicInfo.facilityAcctNo }} </span>
            <span v-else class="warning--text"> (Not a GP Account!) </span>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Facility Name:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.facilityName }}</v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Address:</v-flex>
          <v-flex xs8 text-xs-left pt-1>
            {{ quoteData.basicInfo.facilityAddress2 }}
            <!-- {{ quoteData.basicInfo.facilityAddress3 }} -->
            <br>
            {{ quoteData.basicInfo.facilityCity }}
            {{ quoteData.basicInfo.facilityState }},
            {{ quoteData.basicInfo.facilityZip }}
            <br>
            {{ quoteData.basicInfo.facilityCountry }}
        </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Contact:</v-flex>
          <v-flex xs8 text-xs-left pt-1>
            {{ quoteData.basicInfo.contactName }}
            <span v-if="quoteData.basicInfo.contactId" class="success--text"> (CRM Contact) </span>
            <span v-else class="warning--text"> (Not a Salesforce Contact!) 
              <!-- 20220511, Jeff hide this button for now  -->
                <!-- <v-btn v-show="allowAddSalesforceContact" small color="primary"
                @click="onAddQuoteContactToSalesforce">Add New Contact To Salesforce</v-btn> -->
              <!-- <v-btn v-show="allowAddSalesforceOpportunity" small color="primary"
                @click="onAddOpportunityToSalesforce">Add Oppotunity To Salesforce</v-btn> -->
            </span>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Title:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.title }}</v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Department.:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.department }}</v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Phone.:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.phone }}</v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Email.:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.email }}</v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Quote Date:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.quoteDate | morph-date("MM/DD/YYYY") }}</v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Expiration Date:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.quoteExpirationDate | morph-date("MM/DD/YYYY") }}</v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Special Instruction:</v-flex>
          <!-- <v-flex xs8 text-xs-left pt-1 style="white-space:pre;"> -->
          <v-flex xs8 text-xs-left pt-1>
              {{ quoteData.basicInfo.notes }}
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Freight Information:</v-flex>
          <!-- <v-flex xs8 text-xs-left pt-1 style="white-space:pre;"> -->
          <v-flex xs8 text-xs-left pt-1>
              {{ quoteData.basicInfo.freightInfo }}
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 body-2 pt-1>GPO Affiliated:</v-flex>
          <!-- <v-flex xs8 text-xs-left pt-1 style="white-space:pre;"> -->
          <v-flex xs8 text-xs-left pt-1>
              {{ quoteData.basicInfo.gpoAffiliated }}
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text dense v-if='canViewInternalInfo'>
        <!-- PriceLevel removed - GP-specific, not used in GShape -->
        <!-- <v-layout row>
          <v-flex xs4 body-2 pt-1>Price Level:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.facilityPriceLevel }}</v-flex>
        </v-layout> -->
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Territory:</v-flex>
          <v-flex xs8 text-xs-left pt-1>
            {{ quoteData.basicInfo.facilityTerritory }} 
            <!-- /
            {{ quoteData.basicInfo.facilityRegion }}  -->
          </v-flex>
        </v-layout>       
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Term:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.facilityPaymentType }}</v-flex>
        </v-layout>       
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Freight:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.facilityShipMethod.value }}</v-flex>
        </v-layout>       
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Sales Rep:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.salesRep?quoteData.basicInfo.salesRep.name : '' }}</v-flex>
        </v-layout>       
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Cs Rep:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.csRep?quoteData.basicInfo.csRep.name : '' }}</v-flex>
        </v-layout>       
        <v-layout row>
          <v-flex xs4 body-2 pt-1>Is Rep:</v-flex>
          <v-flex xs8 text-xs-left pt-1>{{ quoteData.basicInfo.isRep?quoteData.basicInfo.isRep.name : '' }}</v-flex>
        </v-layout>       

      </v-card-text>
      <v-card-text v-show="quoteData.salesforceOpportunityUrl">
        <v-layout row >
          <v-flex xs12 text-xs-left pt-1>
            <a :href="quoteData.salesforceOpportunityUrl" target="_blank">
            Click here to view the related Salesforce Opportunity
            </a>
          </v-flex>
            
        </v-layout>       
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    props: ['quoteData'],
  components: {
    },
  data: () => ({
    }),
  computed: {
    ...mapGetters('auth', [
      'userHasInternalRole',
      'userHasSalesQuoteManagerRole',
    ]),
    canViewInternalInfo() {
      return this.userHasSalesQuoteManagerRole || this.userHasInternalRole
    },
    allowAddSalesforceContact() {
      return this.quoteData.basicInfo.facilityAcctNo 
        && !this.quoteData.basicInfo.contactId
        && this.userHasInternalRole
    },
    allowAddSalesforceOpportunity() {
      return this.userHasInternalRole
    }
  },
  watch: {},
  methods: {
    ...mapActions('pubQuoteEdit', [
      'addQuoteContactToSalesforce',
      'addQuoteAsOppotunity'
    ]),
    onEditQuote() {
      this.$router.push({name: 'pub-quote-edit', params: {id: this.quoteData.id}})
    },
    async onAddQuoteContactToSalesforce() {
      if(!confirm('Before you add this contact to Salesforce, please make sure there is no duplicated contact. Are you sure?')){
        return
      }

      var result = await this.addQuoteContactToSalesforce(this.quoteData.id)
      if(result == 'success') {
        // this.$emit('reloadQuoteData', null)
        this.$emit('reloadQuoteData')
        // console.log('send out reloadQuoteData')
      }
      else{
        alert(result)
      }
    },
    async onAddOpportunityToSalesforce() {
      if(!confirm('Are you sure?')){
        return
      }

      var result = await this.addQuoteAsOppotunity(this.quoteData.id)
      if(result == 'success') {
        // this.$emit('reloadQuoteData', null)
        this.$emit('reloadQuoteData')
        // console.log('send out reloadQuoteData')
      }
      else{
        alert(result)
      }
    }
  },
  created: async function() {
  },
  mounted: function() {},
  destroyed: function() {
  }
};
</script>